//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogFormHtml from "@/0/components/comForm/comDialog/comDialogFormHtml";
export default {
  props: ["controlItem"],
  components: {
    "dialog-form-html": DialogFormHtml
  },
  data() {
    return {};
  },
  created() {},

  methods: {

    onFullClick(){
      
      this.$refs.comDialogFormHtml.initForm(this.controlItem);
      this.$refs.comDialogFormHtml.Show();

    },


  }
};
